import React, { useState, useEffect } from 'react';
import { useSortableData } from '../../dashboard-util/dashboard-utils';
import ArrowDown from "../../../../assets/icons/ArrowDown.svg";
import ArrowHover from "../../../../assets/icons/ArrowHover.svg";
import ArrowUp from "../../../../assets/icons/ArrowUp.svg";
import TasksModalBase from '../helper/task-modal-base';
import './work-load.scss';
import PropTypes from 'prop-types';

const WorkLoadWidget = ({ data }) => {
  const [show, setShow] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [members, setMembers] = useState(data);
  const { items, requestSort, getArrowDirectionFor } = useSortableData(members.WorkLoadData);

  const tableHeaders = [
    { text: "Members", sortKey: "Name" },
    { text: "Role", sortKey: "Role" },
    { text: "Actionable STRS", sortKey: "ActionableSTRs" },
    { text: "Avg. STR Completion Time", sortKey: "AverageCompletionTime" }
  ];

  useEffect(() => {
    setMembers(data);
  }, [data]);

  const showModal = (member) => {
    setSelectedMember(member);
    setShow(true);
  };

  const closeModal = () => {
    setShow(false);
    setSelectedMember(null);
  };

  return (
    <div className="workload-dashboard-container">
    <div className="custom-width workload-table-wrapper margin-top-workload">
      <div className="DashboardTableWrapperWorkLoad WorkLoadDashboard">
        <div className="DashboardTableHeader" style={{ height: '70px' }}>
          <th className="workloadDashboardTableTitle">
            <span>Investigator Workload</span>
          </th>
        </div>

        <table className="WorkLoadDashboard auto-adjust-table">
          <thead className="workloadHeader">
            <tr className="tableColumnTitles tableHeader">
              {tableHeaders.map(({ text, sortKey }, index) => (
                <th
                  key={sortKey}
                  className={`workloadheaderSorted th-hover textEllipsis`}
                  style={{
                    textAlign: index === 0 ? 'left' : 'center',
                    padding: index === 0 ? '10px 20px 10px 23px' : '10px',
                    verticalAlign: 'middle',
                    cursor: 'pointer',
                    position: 'relative',
                  }}
                  onClick={() => requestSort(sortKey)}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: index === 0 ? 'flex-start' : 'center',
                      alignItems: 'center',
                      width: '100%',
                      height: '100%',
                    }}
                  >
                    <div className="containerTextSorted">
                      <p className="textSorted">{text}</p>
                    </div>

                    {getArrowDirectionFor(sortKey, 'ascending') && (
                      <img className="arrowDirection" alt="Arrow up" src={ArrowUp} />
                    )}
                    {getArrowDirectionFor(sortKey, 'descending') && (
                      <img className="arrowDirection" alt="Arrow down" src={ArrowDown} />
                    )}
                    {getArrowDirectionFor(sortKey) && (
                      <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover} />
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>

          <tbody className="tableBody workloadBody">
            {items?.map((item, index) => (
              <tr key={index}>
                <td style={{ textAlign: 'left', padding: '10px 20px 10px 20px' }}>
                  {item.Name}
                </td>
                <td style={{ textAlign: 'center', padding: '10px' }} >
                  {item.Role}
                </td>
                <td 
                    style={{ textAlign: 'center', padding: '10px', cursor: item.ActionableSTRs > 0 ? 'pointer' : 'default' }} 
                
                    key={item.ActionableSTRs + index}
                >
                    <span 
                        onClick={item.ActionableSTRs > 0 ? () => showModal(item) : null} 
                        onKeyDown={(e) => {
                          if (item.ActionableSTRs > 0 && e.key === 'Enter') {
                            showModal(item);
                          }
                        }} 
                        tabIndex="0"
                        key="expand"
                        className={item.ActionableSTRs > 0 ? 'hoverWorkLoad' : ''}
                    >
                        {item.ActionableSTRs}
                    </span>
                </td>
                <td style={{ textAlign: 'center', padding: '10px' }}>
                  {item.AverageCompletionTime}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {show && (
        <TasksModalBase
          show={show}
          onHide={closeModal}
          title={selectedMember.Name}
          subtitle="Actionable STRs"
          tasks={selectedMember.WorkLoadData}
        />
      )}
    </div>
    </div>
  );
};

export default WorkLoadWidget;

WorkLoadWidget.propTypes = {
  data: PropTypes.shape({
    WorkLoadData: PropTypes.arrayOf(
      PropTypes.shape({
        Name: PropTypes.string,
        Role: PropTypes.string,
        AverageCompletionTime: PropTypes.string,
        ActionableSTRs: PropTypes.number,
        AlertDate: PropTypes.instanceOf(Date),
        NumberOfActiveDays: PropTypes.number,
        Priority: PropTypes.string,
        STRID: PropTypes.string,
        Status: PropTypes.string,
        TriggerSource: PropTypes.string,
        TriggerType: PropTypes.string
      })
    )
  }).isRequired
}